import { KB_PROMPT_MAX_CHARS, prepareKbForPrompt } from '../kb-assistant/kbPromptBudget';

/** Same cap as email, SMS, chat, and follow-up. */
export const KB_TEST_MAX_CHARS = KB_PROMPT_MAX_CHARS;

export const DEFAULT_AI_TEST_MESSAGE =
  "Hi, I'm looking at your services — what do you charge and what's included?";

export function boundKbForTest(content, maxChars = KB_TEST_MAX_CHARS) {
  const prepared = prepareKbForPrompt(String(content || ''), maxChars);
  if (prepared.dropped > 0) {
    console.warn(
      `[KB PROMPT] test: knowledge base larger than the AI reads — dropped ${prepared.dropped} scraped characters. Operator rules kept in full (${prepared.rules.length} chars).`
    );
  }
  return prepared.text;
}

const UNGROUNDED_PHRASES = [
  /pricing will be confirmed by the team/i,
  /i['']m not sure about that/i,
];

function looksLikePricingQuestion(message) {
  return /pric(e|ing)|how much|what do you charge|\bcost\b|\bfee\b|\bretainer\b/i.test(
    String(message || '')
  );
}

function kbHasPriceTokens(knowledgeBase) {
  return /\$\d|\bUSD\b|\bpric(e|ing)\b|\bretainer\b|\bfee\b/i.test(String(knowledgeBase || ''));
}

/**
 * Advisory note only — "I'm not sure" is sometimes the correct answer.
 * Returns copy or null. Never used to block send or style as an error.
 */
export function groundingGuidance({ leadMessage, aiReply, knowledgeBase } = {}) {
  const replyLooksUngrounded = UNGROUNDED_PHRASES.some((re) => re.test(aiReply || ''));
  const pricingGap = looksLikePricingQuestion(leadMessage) && !kbHasPriceTokens(knowledgeBase);
  if (!replyLooksUngrounded && !pricingGap) return null;
  return 'This answer may not be fully grounded in your knowledge base. That can be the right call when the KB does not cover the question — add the missing details above and test again if you want a firmer answer.';
}
